/**
 * @file index
 * @author Cuttle Cong
 * @date 2018/5/1
 * @description
 */

export default function badge(element) {
  this.opt.badge = Object.assign({}, this.opt.badge)


  const ctx = this
}
